import Console from '@/shared/console';
import documentsProvider from '@/apiProviders/documents.provider';

const documentsModule = {
  namespaced: true,
  state: {
    documents: [],
    shouldReloadDocumentsTable: false,
    shouldReloadDocumentsProfile: false,
  },
  actions: {
    async fetchSearchDocuments({ state, commit, rootGetters }, data) {
      try {
        const {
          data: { total, rows, pageSize, nSkip },
        } = await documentsProvider.searchDocuments(data);
        return { total, rows, pageSize, nSkip };
      } catch (error) {
        Console.log(error.response);
      }
    },

    setShouldReloadDocumentsTable({ state, commit, rootGetters }, data) {
      commit('setShouldReloadDocumentsTable', data);
    },

    setShouldReloadDocumentsProfile({ state, commit, rootGetters }, data) {
      commit('setShouldReloadDocumentsProfile', data);
    },
  },

  mutations: {
    setShouldReloadDocumentsTable(state, { shouldReloadDocumentsFlag }) {
      state.shouldReloadDocumentsTable = shouldReloadDocumentsFlag;
    },

    setShouldReloadDocumentsProfile(state, { shouldReloadDocumentsFlag }) {
      state.shouldReloadDocumentsProfile = shouldReloadDocumentsFlag;
    },
  },

  getters: {},
};

export default documentsModule;
